import {
  Box,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import styles from "pages/phNewPendingTasks/style.module.scss";
import React, { useEffect, useState } from "react";
import PaginationComponent from "shared/components/pagination";
import RangeDatePicker from "shared/components/rangeDatePicker";
import useWindowSize from "shared/customHooks/windowSize";
import {
  headers_enums,
  partners_request,
  pending_mous,
  schools_requests,
  support_chat_authors,
  support_chat_publishers,
  support_chat_schools,
} from "./constants";
import SupportChatPublishers from "./supportChatPublishers";
import SupportChatAuthors from "./supportChatAuthors";
import SupportChatSchools from "./supportChatSchools";
import SchoolRequests from "./schoolsRequests";
import PartnersRequests from "./partnersRequests";
import PendingMOUs from "./pendingMOUs";
import { useNavigate, useParams } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";

function AdminPendingTasks() {
  const params = useParams();
  const navigate = useNavigate();
  const screenWidth = useWindowSize();
  const [activeTab, setActiveTab] = useState<any>(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [headers, setHeaders] = useState<any>(support_chat_publishers);
  const [activePage, setActivePage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");

  const tabs = [
    {
      value: 0,
      label: "Support Chats - Publisher",
      counter: 5,
      tabs_enum: "support_publisher",
    },
    {
      value: 1,
      label: "Support Chats - Author",
      counter: 8,
      tabs_enum: "support_author",
    },
    {
      value: 2,
      label: "Support Chats - School",
      counter: 6,
      tabs_enum: "support_school",
    },
    {
      value: 3,
      label: "School Requests",
      counter: 24,
      tabs_enum: "school_requests",
    },
    {
      value: 4,
      label: "Partners Request",
      counter: 11,
      tabs_enum: "partners_requests",
    },
    {
      value: 5,
      label: "Pending MOUs",
      counter: 5,
      tabs_enum: "pending_mous",
    },
  ];

  const handleChange = (event: any, newValue: number) => {
    setActiveTab(newValue);

    let filteredTab: any = tabs.findIndex((item) => item?.value === newValue);

    if (filteredTab > -1) {
      navigate(
        routeConstant.pendingTasks.path
          .replace(":keyword", "admin")
          .replace(":task", tabs[filteredTab]?.tabs_enum)
      );
    }

    if (newValue === headers_enums.support_chat_publishers) {
      setHeaders(support_chat_publishers);
    } else if (newValue === headers_enums.support_chat_authors) {
      setHeaders(support_chat_authors);
    } else if (newValue === headers_enums.support_chat_schools) {
      setHeaders(support_chat_schools);
    } else if (newValue === headers_enums.schools_requests) {
      setHeaders(schools_requests);
    } else if (newValue === headers_enums.partners_request) {
      setHeaders(partners_request);
    } else if (newValue === headers_enums.pending_mous) {
      setHeaders(pending_mous);
    }
  };

  useEffect(() => {
    let filteredTab: any = tabs.findIndex(
      (item) => item?.tabs_enum === params?.task
    );

    if (filteredTab > -1) {
      handleChange("", tabs[filteredTab]?.value);
    }

    // eslint-disable-next-line
  }, [params?.task]);

  return (
    <div>
      <div className={styles.topLevelContainer}>
        <div className={styles.headingContainer}>
          <label className={styles.heading}>Pending Task of Admin</label>
          <label className={styles.subHeading}>
            Table with pending task tabs, list and actions to perform.
          </label>
        </div>
        <div className={styles.rangePicker}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            doubleLabel={true}
          />
        </div>
      </div>

      <div className={styles.mainContainer}>
        <Box className={styles.boxContainer}>
          <Tabs
            value={activeTab}
            onChange={handleChange}
            className={styles.tab}
            TabIndicatorProps={{
              style: {
                backgroundColor: "black",
              },
            }}
          >
            {tabs?.map((item: any, index: any) => {
              return (
                <Tab
                  label={
                    <div
                      className={classNames(
                        styles.tabs,
                        activeTab === item?.value && styles.active
                      )}
                    >
                      <label className={styles.tabLabel}> {item?.label}</label>
                      <label className={styles.tabCounter}>
                        {item?.counter}
                      </label>
                    </div>
                  }
                />
              );
            })}
          </Tabs>
        </Box>
        <Box className={styles.toptableContainer}>
          <div className={styles.headingContainer}>
            {activeTab === headers_enums.support_chat_publishers ? (
              <>
                <label className={styles.tableHeading}>
                  Support Chat with Publishers
                </label>
              </>
            ) : activeTab === headers_enums.support_chat_authors ? (
              <>
                <label className={styles.tableHeading}>
                  Support Chat with Authors
                </label>
              </>
            ) : activeTab === headers_enums.support_chat_schools ? (
              <>
                <label className={styles.tableHeading}>
                  Support Chat with Schools
                </label>
              </>
            ) : activeTab === headers_enums.schools_requests ? (
              <>
                <label className={styles.tableHeading}>Schools Request</label>
              </>
            ) : activeTab === headers_enums.partners_request ? (
              <>
                <label className={styles.tableHeading}>Partners Request</label>
              </>
            ) : activeTab === headers_enums.pending_mous ? (
              <>
                <label className={styles.tableHeading}>Pending MOUs</label>
              </>
            ) : (
              " "
            )}
          </div>
          <div className={styles.gridContainer}>
            <Icons.SearchIcon className={styles.searchIcon} />
            <input
              placeholder="Search"
              className={styles.input}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </Box>

        <TableContainer
          component={Paper}
          className={styles.tableContainer}
          sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
          id="table-view-dashboard"
        >
          <Table aria-label="simple table">
            <TableHead className={styles.tableHead}>
              <TableRow>
                {headers?.map((item: any) => {
                  return (
                    <>
                      <TableCell>{item}</TableCell>
                    </>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody className={styles.tableBody}>
              {activeTab === headers_enums.support_chat_publishers ? (
                <SupportChatPublishers />
              ) : activeTab === headers_enums.support_chat_authors ? (
                <SupportChatAuthors />
              ) : activeTab === headers_enums.support_chat_schools ? (
                <SupportChatSchools />
              ) : activeTab === headers_enums.schools_requests ? (
                <SchoolRequests />
              ) : activeTab === headers_enums.partners_request ? (
                <PartnersRequests />
              ) : activeTab === headers_enums.pending_mous ? (
                <PendingMOUs />
              ) : (
                <></>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <PaginationComponent
          totalPages={"1"}
          activePage={activePage}
          setActivePage={setActivePage}
        />
      </div>
    </div>
  );
}

export default AdminPendingTasks;
